import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import MAcordeaoImportadores from "@/components/Importacoes/MAcordeaoImportadores/MAcordeaoImportadores.vue"
  import MCarregadorDeArquivos from "@/components/Importacoes/MCarregadorDeArquivos/MCarregadorDeArquivos.vue"
  import { computed } from "vue"

  interface Props {
    escritor: any
    cabecalho: string
    textoEstadoVazio: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OAcordeaoDeImportarArquivos',
  props: {
    escritor: null,
    cabecalho: null,
    textoEstadoVazio: null
  },
  setup(__props: any) {

const props = __props as {
    escritor: any
    cabecalho: string
    textoEstadoVazio: string
  }

  

  const idImportacao = computed(() => {
    return props.cabecalho.toLowerCase().replace(/ /g, "-")
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MAcordeaoImportadores, {
    "data-testid": "MAcordeaoImportadores",
    titulo: __props.cabecalho
  }, {
    default: _withCtx(() => [
      _createVNode(MCarregadorDeArquivos, {
        "escritor-de-arquivos": __props.escritor,
        "formatos-aceitos": ['.xlsx'],
        "id-importacao": _unref(idImportacao),
        "tamanho-maximo-em-bytes": 500000,
        "texto-estado-vazio": __props.textoEstadoVazio
      }, null, 8, ["escritor-de-arquivos", "formatos-aceitos", "id-importacao", "texto-estado-vazio"])
    ]),
    _: 1
  }, 8, ["titulo"]))
}
}

})